module.exports = __webpack_public_path__ + "static/img/game-level0.2be4206.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/game/game-level0.png
// module id = AiZ3
// module chunks = 1